import UAParser from 'ua-parser-js';

export const BrowserAbilities = {
  hoverEnabled() {
    const uaParser = new UAParser();
    return !_.includes(['mobile', 'tablet', 'wearable'], uaParser.getDevice().type);
  },

  canUseIntersectionObservers() {
    return typeof IntersectionObserver !== 'undefined';
  },

  init() {
    if (this.hoverEnabled()) {
      document.documentElement.classList.add('hover-enabled');
    }
  },
};
